import { render, staticRenderFns } from "./ApplicationCore.vue?vue&type=template&id=82c1cee0&"
import script from "./ApplicationCore.vue?vue&type=script&lang=js&"
export * from "./ApplicationCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports